module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Uhr_BG.2351b7c5.jpg";